import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DropDownMultiCheck } from "../AdvanceSearch/DropDownMultiCheck";
import { BetweenDates } from "../AdvanceSearch/Betweendates";
import EditRating from "../../../components/EditRating";
import { InterviewService } from "../../../services/InterviewService";
import { JobRoleDetailService } from "../../../services/JobRoleDetailService";
import { AvailabilityService } from "../../../services/AvailabilityService";
import moment from "moment";
import { CommonService } from "../../../services/CommonService";
import { useSideDrawerSearch } from "../../../components/SideDrawerSearch";
import JobRoleDetails from "../../../components/JobRoleDetailsTree/JobRoleDetails";
import { TechRoleService } from "../../../services/TechRoleService";
import { TagService } from "../../../services/TagService";

export default function InterviewListFilters({
  searchObject,
  setSearchObject
}) {
  const [businessAreas, setBusinessAreas] = useState([]);
  const [techAreas, setTechAreas] = useState([]);
  const [techRoles, setTechRoles] = useState([]);
  const [skills, setSkills] = useState([]);
  const [managers, setManagers] = useState([]);
  const [availability, setAvailability] = useState([]);
  const [tags, setTags] = useState([]);
  const { t } = useTranslation();

  const { onChangeFilters } = useSideDrawerSearch();

  useEffect(() => {
    getBusinessAreas();
    getTechAreas();
    InterviewService.GetManagerList().then((data) => {
      setManagers(data);
    });
    AvailabilityService.getAvailabilityStatus().then((data) => {
      setAvailability(data);
    });

    TagService.getTagsList().then((data) => {
      setTags(data);
    });
  }, []);

  useEffect(() => {
    if (searchObject.techAreaId) {
      getTechRoles(searchObject.techAreaId);
    } else {
      TechRoleService.getAllTechRoles().then((data) => setTechRoles(data));
    }
  }, [searchObject.techAreaId]);

  useEffect(() => {
    if (searchObject.techRoleId) {
      JobRoleDetailService.getTechSkillsByRole(searchObject.techRoleId).then(
        (data) => {
          setSkills(data);
        }
      );
    } else {
      CommonService.getTechSkills().then((data) => {
        setSkills(data);
      });
    }
  }, [searchObject.techRoleId]);

  function getBusinessAreas() {
    JobRoleDetailService.getAllBusinessAreas().then((data) => {
      setBusinessAreas(data);
    });
  }

  function getTechAreas() {
    JobRoleDetailService.getAllTechAreas().then((data) => {
      setTechAreas(data);
    });
  }

  function getTechRoles(techAreaId) {
    JobRoleDetailService.getAllTechRoles(techAreaId).then((data) => {
      setTechRoles(data);
    });
  }

  function onChange({ target }) {
    if (
      target.name === "recommended" ||
      target.name === "isInAvailabilityList"
    ) {
      setSearchObject({ ...searchObject, [target.name]: target.checked });
      onChangeFilters(target.name, target.name, target.checked);
    } else if (target.name === "techAreaId") {
      setSearchObject({
        ...searchObject,
        [target.name]: target.value,
        techRoleId: null
      });
      if (target.value === "") {
        return;
      } else {
        onChangeFilters(
          target.name,
          techAreas.filter((x) => x.id === parseInt(target.value)).shift()
            .description
        );
      }
    } else if (target.name === "managerId") {
      setSearchObject({
        ...searchObject,
        [target.name]: target.value
      });

      if (target.value === "") {
        return;
      } else {
        onChangeFilters(
          target.name,
          managers.filter((x) => x.id === parseInt(target.value)).shift()
            .nickname
        );
      }
    } else if (target.name === "businessAreaId") {
      setSearchObject({
        ...searchObject,
        [target.name]: target.value,
        techAreaId: null,
        techRoleId: null
      });
      if (target.value === "") {
        return;
      } else {
        onChangeFilters(
          target.name,
          businessAreas.filter((x) => x.id === parseInt(target.value)).shift()
            .description
        );
      }
    } else if (target.name === "techRoleId") {
      setSearchObject({
        ...searchObject,
        [target.name]: target.value,
        skills: []
      });
      if (target.value === "") {
        return;
      } else {
        onChangeFilters(
          target.name,
          techRoles.filter((x) => x.id === parseInt(target.value)).shift()
            .description
        );
      }
    } else if (target.name === "allTechnologies") {
      setSearchObject({
        ...searchObject,
        [target.name]: target.checked
      });
      onChangeFilters(target.name, t("All Technologies"));
    } else {
      setSearchObject({
        ...searchObject,
        [target.name]: target.value
      });
      onChangeFilters(target.name, target.value);
    }
  }

  function onChangeSkills(skills) {
    setSearchObject({
      ...searchObject,
      skills: skills
    });
    onChangeFilters("skills", skills.map((x) => x.description).join(" | "));
  }

  function setSelectedAvailability(availability) {
    setSearchObject({
      ...searchObject,
      availabilityStatus: availability
    });
    onChangeFilters(
      "availabilityStatus",
      availability.map((x) => x.description).join(" | ")
    );
  }

  function changeRanting(rating) {
    setSearchObject({
      ...searchObject,
      rating: rating
    });
    onChangeFilters("rating", "rating " + rating);
  }

  function toggleFavorite() {
    if (searchObject.favorites) {
      setSearchObject({ ...searchObject, favorites: false });
      onChangeFilters("favorites", "favorites" + false);
    } else {
      setSearchObject({ ...searchObject, favorites: true });
      onChangeFilters("favorites", "favorites" + true);
    }
  }

  function setDates(dateObject) {
    if (
      dateObject.startingDate &&
      dateObject.startingDate !== searchObject.startingDate
    ) {
      onChangeFilters(
        "startingDate",

        "startingDate " + moment(dateObject.startingDate).format("YYYY-MM-DD")
      );
    }
    if (
      dateObject.endingDate &&
      dateObject.endingDate !== searchObject.endingDate
    ) {
      onChangeFilters(
        "endingDate",

        "endingDate " + moment(dateObject.endingDate).format("YYYY-MM-DD")
      );
    }
    setSearchObject({
      ...searchObject,
      startingDate: dateObject.startingDate,
      endingDate: dateObject.endingDate
    });
  }
  function onchangeCandidateBusinessAreas(businessAreas) {
    setSearchObject({
      ...searchObject,
      businessAreas: businessAreas
    });
    onChangeFilters(
      "businessAreas",
      businessAreas.map((x) => x.description).join(" | ")
    );
  }
  function onChangeTags(tags) {
    setSearchObject({
      ...searchObject,
      tags: tags
    });
    onChangeFilters("tags", tags.map((x) => x.description).join(" | "));
  }

  return (
    <div>
      <div className="form-group mt-2">
        <label className="form-label" htmlFor="nameOrEmail">
          {t("Name or Email")}
        </label>
        <input
          type="text"
          className="form-control"
          id="nameOrEmail"
          name="nameOrEmail"
          placeholder={t("Name or Email")}
          value={searchObject.nameOrEmail}
          onChange={onChange}
        />
      </div>

      <div className="form-group mt-2">
        <label className="form-label">{t("Business Area")}</label>
        <DropDownMultiCheck
          dataList={businessAreas}
          selecteds={searchObject.businessAreas || []}
          setSelecteds={onchangeCandidateBusinessAreas}
          label={t("Business Area...")}
          hideSelected={true}
        />
      </div>

      <JobRoleDetails
        onChange={onChange}
        searchObject={searchObject}
        techAreas={techAreas}
        techRoles={techRoles}
      />

      <div className="form-group">
        <label className="form-label">{t("Skills")}</label>
        <div className="row">
          <div className="col">
            {" "}
            <DropDownMultiCheck
              dataList={skills}
              selecteds={searchObject.skills || []}
              setSelecteds={onChangeSkills}
              label={t("Skills...")}
            />
          </div>
          <div className="col-2">
            <div className="form-group mt-2">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  checked={searchObject.allTechnologies}
                  name="allTechnologies"
                  id="allTechnologies"
                  onChange={onChange}
                />

                <label className="form-label" for="recommended">
                  <span className="recommended-tab-button">{t("All")}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="form-group mt-2">
        <label className="form-label">{t("Availability")}</label>
        <DropDownMultiCheck
          dataList={availability}
          selecteds={searchObject.availabilityStatus || []}
          setSelecteds={setSelectedAvailability}
          label={t("Availability...")}
        />
      </div>
      <div className="form-group mt-2">
        <label className="form-label">{t("Managers")}</label>
        <select
          id="managerId"
          name="managerId"
          className="form-select"
          onChange={onChange}
          value={searchObject.managerId || ""}
          title={t("Selecione um item da lista.")}
        >
          <option value={""} selected>{t("Select manager...")}</option>
          {managers?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.nickname}
            </option>
          ))}
        </select>
      </div>
      <div className="form-group mt-2">
        <label className="form-label">{t("Tags")}</label>
        <DropDownMultiCheck
          dataList={tags.map((x) => {
            return { id: x.id, description: x.name };
          })}
          selecteds={searchObject.tags || []}
          setSelecteds={onChangeTags}
          label={t("Tags...")}
          hideSelected={true}
        />
      </div>
      <div className="mt-2">
        <BetweenDates
          dateObject={searchObject}
          setObeject={setDates}
          dateStartField="startingDate"
          dateEndField="endingDate"
          placeholderStart={t("Start Date")}
          placeholderEnd={t("End Date")}
          showLabels={true}
        />
      </div>

      <div className="form-group mt-2">
        <label className="form-label">{t("Rating")}</label>

        <EditRating onChange={changeRanting} ratingObj={searchObject} />
      </div>
      <div className="form-group mt-2">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            checked={searchObject.recommended}
            name="recommended"
            id="recommended"
            onChange={onChange}
          />

          <label className="form-label" for="recommended">
            <span className="recommended-tab-button">{t("Shared")}</span>
          </label>
        </div>
      </div>
      <div className="form-group mt-2">
        <div class="form-check">
          <span className="me-2" id="favorite" onClick={toggleFavorite}>
            {" "}
            {searchObject.favorites ? (
              <i class="bi bi-star" style={{ color: "orange" }}></i>
            ) : (
              <i class="bi bi-star" style={{ color: "gray" }}></i>
            )}
          </span>

          <label className="form-label" for="favorite">
            <span className="recommended-tab-button">{t("Favorite")}</span>
          </label>
        </div>
      </div>
      <div className="form-group mt-2">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            checked={searchObject.isInAvailabilityList}
            name="isInAvailabilityList"
            id="isInAvailabilityList"
            onChange={onChange}
          />

          <label className="form-label" for="isInAvailabilityList">
            <span className="recommended-tab-button">
              {t("Is in availabilbity list")}
            </span>
          </label>
        </div>
      </div>
    </div>
  );
}
